/* eslint-disable max-lines */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-use-before-define */
/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import StyleGuide from '@taglivros/oef_componentes/build/components/styleGuide'
import InlineLoader from '../../../components/InlineLoader/InlineLoader'
import PrazoEntrega from '../../../components/PrazoEntrega/PrazoEntrega'
import LogRastreamento from '../../../utils/helpers/rastreamento/LogRastreamento'
import { ReactComponent as Box } from '../../../assets/icons/box.svg'
import { ReactComponent as BlackArrow } from '../../../assets/icons/black-arrow.svg'
import { ReactComponent as Copy } from '../../../assets/icons/copy.svg'

const InformacoesCaixinhaContainer = styled.div`
  padding: 10px;
  background: #f9f9f9;
  > div {
    padding: 3px;
  }

  .box-info {
    align-items: center;
    font-size: 13px;
    display: flex;
    gap: 5px;
    color: #53586f;
    svg path {
      stroke: #53586f;
    }
    svg {
      width: 24px;
    }
  }
  .header-caixinha {
    justify-content: space-between;
    display: flex;
    align-items: center;
    gap: 5px;
    font-size: 14px;
    padding-bottom: 10px;
    .arrow {
      padding-right: 3px;
      svg {
        cursor: pointer;
        transform: ${( { expanded } ) => expanded ? 'rotate(-180deg)' : 'rotate(0deg)'};
        transition: transform 0.5s;
      }
    }
  }
  .bold-text {
    font-weight: 600;
    font-size: 13px;
    line-height: 16px;
    color: #676c84;
    a {
      color: #3f49b5;
    }
  }
  .normal-text {
    font-weight: 400;
    font-size: 13px;
    line-height: 16px;
    color: #676c84;
  }
  .padding3 {
    padding: 3px;
  }
  .number-pedido {
    font-weight: 400;
    font-size: 15px;
    line-height: 16px;
    color: #676c84;
  }
  .div-circle {
    display: flex;
    align-items: center;
    gap: 5px;
  }
  .codigo-rastreio {
    display: flex;
    align-items: center;
    gap: 5px;
    svg {
      cursor: pointer;
    }
    .codigo {
      max-width: 150px;
      overflow-wrap: break-word;
      @media (max-width: ${StyleGuide.mediaQuery.mobile}) {
           max-width: 120px;
        }
      }
    }
  }
  a {
    text-decoration: underline;
    cursor: pointer;
  }
`

const Label = styled.h4`
  font-size: 16px;
  ${StyleGuide.boldFonte}

  @media(max-width: ${StyleGuide.mediaQuery.mobile}) {
    font-size: 16px;
  }
`

const Historico = styled.div`
  padding: 0 10px;

  ${Label} {
    margin: 0 10px 10px -9px;

    @media (max-width: ${StyleGuide.mediaQuery.mobile}) {
      margin-top: -10px;
    }
  }
`

const HeaderDetalhes = styled.span`
  font-size: 16px;
  ${StyleGuide.boldFonte};
  color: #53586f;

`

const Detalhes = styled.ul`
  padding: 15px 10px 0 8px;

  > li {
    margin-bottom: 15px;
  }

  .circle {
    background: #676c84;
    width: 10px;
    height: 10px;
    border-radius: 50%;
  }
`

const Helper = styled.div`
  font-size: ${StyleGuide.tipografia.textoPequeno};
  margin-top: 3px;
  color: #343a4f;
`

const Toast = styled.div`
  background: rgb(0, 155, 191, 0.6);
  position: fixed;
  top: 120px;
  left: 40%;
  @media (max-width: ${StyleGuide.mediaQuery.mobile}) {
    left: 25%;
  }
  width: 200px;
  z-index: 9999;
  height: 20px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  span {
    color: white;
  }
  animation: mymove 6s infinite;

  @keyframes mymove {
    0% {
      top: -20px;
    }
    40% {
      top: 10%;
    }
    60% {
      top: 10%;
    }
    100% {
      top: -40px;
    }
  }
`

function InformacoesCaixinha( { detalhePedido, loadingDetalhes, color } ) {
  const [ logsExibicao, setLogsExibicao ] = useState( null )
  const [ expanded, setExpanded ] = useState( false )
  const [ toast, setToast ] = useState( false )
  function handleCLickArrow() {
    setExpanded( !expanded )
  }
  const allowShipping = [ 'Correios' ]
  const tansportadoraName = detalhePedido?.entrega?.transportadora?.nome?.trim() || ''
  useEffect( () => {
    if ( !detalhePedido?.entrega?.logs ) {
      return setLogsExibicao( null )
    }
    const logs = detalhePedido.entrega.logs.map( log => new LogRastreamento( log ) )

    const constlogsExibicao = LogRastreamento.constroiListaExibicao( logs )

    setLogsExibicao( constlogsExibicao.reverse() )
  }, [ detalhePedido ] )

  function handleClickCopy() {
    setToast( true )
    navigator.clipboard.writeText( detalhePedido.entrega.transportadora.codigoRastreamento )
    setTimeout( () => setToast( false ), 6000 )
  }

  return (
    <div>
      {loadingDetalhes ? (
        <InlineLoader
          cor={ color }
          isCenter
        />
      ) : (
        <>
          <InformacoesCaixinhaContainer expanded={ expanded }>
            <div
              className="header-caixinha"
              onClick={ handleCLickArrow }
            >
              <div className="box-info">
                <Box />

                <span>Informações da caixinha</span>
              </div>

              <div className="arrow">
                <BlackArrow />
              </div>
            </div>

            <div>
              <span className="number-pedido">
                {`Nº de pedido: ${detalhePedido.id}`}
              </span>
            </div>

            {detalhePedido.mesTag === 'Setembro / 2024' && detalhePedido.modalidade === 'Inéditos' ? (
              <div>
                <span className="number-pedido">** Despachos a partir de 28/08</span>
              </div>
            ) : null }

            <PrazoEntrega
              previsaoEntrega={ detalhePedido.entrega.previsaoEntrega }
            />

            <div>
              <span className="bold-text">
                Empresa responsável pela entrega:
              </span>

              <span className="normal-text">
                {` ${detalhePedido.entrega.transportadora.nome || '-'}`}
              </span>
            </div>

            {allowShipping.includes( tansportadoraName ) && (
              <div className="codigo-rastreio">
                <span className="bold-text">Código de rastreio:</span>

                <span className="normal-text codigo">
                  {` ${detalhePedido.entrega.transportadora
                    .codigoRastreamento || '-'}`}
                </span>

                {detalhePedido.entrega.transportadora.codigoRastreamento ? <Copy onClick={ handleClickCopy } /> : null}
              </div>
            )}

            {detalhePedido.entrega.transportadora.linkRastreamento ?
              <div className="bold-text">
                <a
                  href={ detalhePedido.entrega.transportadora.linkRastreamento }
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  <span>Acompanhe o seu pedido clicando aqui</span>
                </a>
              </div> : null}

            {expanded ? logsExibicao ? (
              <Historico>
                <Detalhes>
                  {logsExibicao.map( log => (
                    <li key={ log.timestamp }>
                      <div className="div-circle">
                        <span className="circle"> </span>

                        <HeaderDetalhes>{log.titulo}</HeaderDetalhes>
                      </div>

                      <Helper>
                        {log.textoData}

                        {log.descricao ? ` | ${log.descricao}` : null}
                      </Helper>
                    </li>
                  ) )}
                </Detalhes>
              </Historico>
            ) : (
              <span className="normal-text padding3">
                Seu código de rastreio ainda não foi gerado
              </span>
            ) : null}
          </InformacoesCaixinhaContainer>

          {toast ?
            <Toast>
              <span>Código copiado!</span>
            </Toast> : null}
        </>
      )}
    </div>
  )
}

export default InformacoesCaixinha
